// extracted by mini-css-extract-plugin
module.exports = {"sharingList":"sharingList___2ZZRw"};